import { z } from 'zod';
import { LANGUAGES } from '../constants/locales';

export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 128;

export const passwordSchema = z.string().min(PASSWORD_MIN_LENGTH).max(PASSWORD_MAX_LENGTH);

export const usernameSchema = z
  .string()
  .trim()
  .toLowerCase()
  .min(3)
  .max(32)
  .regex(/^[a-z0-9._-]+$/, 'validation.usernameFormat');

export const fullNameSchema = z.string().trim().min(1).max(80);

export const loginSchema = z.object({
  username: z.string().trim().toLowerCase().min(1).max(64),
  password: z.string().min(1).max(PASSWORD_MAX_LENGTH),
});
export type LoginInput = z.infer<typeof loginSchema>;

export const forgotPasswordSchema = z.object({
  /** Username or email address. */
  identifier: z.string().trim().toLowerCase().min(1).max(254),
});
export type ForgotPasswordInput = z.infer<typeof forgotPasswordSchema>;

export const resetPasswordSchema = z.object({
  token: z.string().min(20).max(200),
  password: passwordSchema,
});
export type ResetPasswordInput = z.infer<typeof resetPasswordSchema>;

export const changePasswordSchema = z
  .object({
    currentPassword: z.string().min(1).max(PASSWORD_MAX_LENGTH),
    newPassword: passwordSchema,
  })
  .refine((data) => data.currentPassword !== data.newPassword, {
    path: ['newPassword'],
    message: 'validation.passwordSameAsCurrent',
  });
export type ChangePasswordInput = z.infer<typeof changePasswordSchema>;

/** What users can change on their own profile (USR-10). */
export const updateProfileSchema = z
  .object({
    fullName: fullNameSchema,
    language: z.enum(LANGUAGES),
    /** ALR-06, ALR-08: alert emails and the daily summary. */
    notifications: z.object({ email: z.boolean(), digest: z.boolean() }),
  })
  .partial();
export type UpdateProfileInput = z.infer<typeof updateProfileSchema>;
